jQuery(document).ready(function ($) {
  // Close cart when clicking outside
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.top-cart-holder').length) {
      $('.top-cart-holder .cart-target').removeClass('opened');
    }
  });

});